import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import set from 'set-value';
import mapState from './map-state';
export var connect = function connect(_ref) {
  var Vue = _ref.Vue,
      store = _ref.store,
      _ref$actions = _ref.actions,
      actions = _ref$actions === void 0 ? {} : _ref$actions,
      _ref$binding = _ref.binding,
      binding = _ref$binding === void 0 ? 'store' : _ref$binding;

  if (!store) {
    console.warn("[redux-vuex]: No store attatched, please provide an redux-store to the connector");
    return;
  }

  var syncStateWithComponent = function syncStateWithComponent(component, bindings) {
    return function () {
      var _context;

      var state = store.getState();

      _forEachInstanceProperty(_context = _Object$keys(bindings)).call(_context, function (prop) {
        var getter = bindings[prop];

        if (!getter) {
          return;
        }

        set(component._data, prop, getter(state));
      });
    };
  };

  Vue.mixin({
    beforeCreate: function beforeCreate() {
      var _this = this;

      this.REDUX_VUEX_STORE = binding;

      if (!this[this.REDUX_VUEX_STORE]) {
        this[this.REDUX_VUEX_STORE] = store;
      }

      if (!this.REDUX_VUEX_ACTIONS) {
        this.REDUX_VUEX_ACTIONS = actions;
      }

      this.mapState = function () {
        return mapState.apply(void 0, arguments).call(_this);
      };
    },
    created: function created() {
      // Root component should not interact with the store
      if (!this.$root) {
        return;
      } // If the helper methods (mapState) registered store bindings, create subscriptions


      if (this.REDUX_VUEX_BINDINGS) {
        this.unsubscribe = store.subscribe(syncStateWithComponent(this, this.REDUX_VUEX_BINDINGS));
      }
    },
    beforeDestroy: function beforeDestroy() {
      this.unsubscribe && this.unsubscribe();
    }
  });
};